import { render, staticRenderFns } from "./PageVmSettings.vue?vue&type=template&id=7cc1d458&"
import script from "./PageVmSettings.vue?vue&type=script&lang=js&"
export * from "./PageVmSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports